import { NgModule } from '@angular/core';
import { AlertSmallComponent } from './alert-small.component';
@NgModule({
  declarations: [AlertSmallComponent],
  exports: [AlertSmallComponent],
})
export class AlertSmallModule { }
